
import { ElMessage } from "element-plus";
import { getEnum, login } from "@/api/index";
 
import { useStore } from "vuex";
import { ElForm } from "element-plus";
import Uploadimg from "@/components/uploadimg/Index.vue";
import { putAttract ,getAllAttractType } from "@/api/backstage";
import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增招商加盟",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
   components: {
    Uploadimg
  },
  emits: ["close"],
  setup(opt, contex) {
    const ruleFormRef = ref(ElForm);
    let isEdit = false;
    let show = opt.open;
    const store = useStore();

    const dataMap: any = reactive({
      attrType:'',
      ruleForm: {
        title: "",
        typeId: "",
        fileId:'',
        description:'',
        sortNum:'',
      },
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
        ],
        typeId: [
          { required: true, message: "请选择加盟类型", trigger: "blur" },
        ],
      },

      async getAttractType() {
        const res = await getAllAttractType();
         dataMap.attrType = res?.data ?? [];
      },

      async putNewData() {
        let query: any = JSON.parse(JSON.stringify(dataMap.ruleForm));
        query.urgencyStatus?query.urgencyStatus=1:query.urgencyStatus=0;
        const res = await putAttract(query);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          contex.emit("close", false);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });

 
    if (opt.row) {
      isEdit = true;
      dataMap.ruleForm = opt.row;
      if(opt.row.urgencyStatus === 1 ){
        dataMap.ruleForm.urgencyStatus = true;
      }else{
        dataMap.ruleForm.urgencyStatus= false;
      }
       if(opt.row.fileName) dataMap.ruleForm.fileUrl =  localStorage.getItem("fileUrel") + opt.row.fileName;
      
    }

    const submitForm = () => {
      const form = unref(ruleFormRef);
      form.validate((valid: any) => {
        if (valid) {
          dataMap.putNewData();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    const close = () => {
      const form = unref(ruleFormRef);
      contex.emit("close", false);
    };

    const onSuccess = (val: any) => {
      dataMap.ruleForm.fileId = val.id;
      dataMap.ruleForm.fileName = val.fileName;
    };
 

    onMounted(() => {
      dataMap.getAttractType();
    });

    return {
      show,
      store,
      isEdit,
      ruleFormRef,
      submitForm,
      onSuccess,
      close,
      ...toRefs(dataMap),
    };
  },
});
